import { useContext, useEffect, useState } from "react"
import { scenes } from "../../context/scenes";
import '../../style/components/showDetails.css'
import Days from '../../data/days.json'
import { useTranslation } from "react-i18next";

export default function ShowDetails (props) {
    const { t } = useTranslation();
    const [typeSalary, setTypeSalary] = useState("");
    const { setSceneEmp } = useContext(scenes);

    useEffect(() => {
        if(props.data.salary.type === "perMonth"){
            setTypeSalary(t("salarySystem:monthly"));
        }
        else if(props.data.salary.type === "perHour") {
            setTypeSalary(t("salarySystem:byHour"));
        }
        else if(props.data.salary.type === "perDay") {
            setTypeSalary(t("salarySystem:daily"));
        }
        else if(props.data.salary.type === "perOrder") {
            setTypeSalary(t("salarySystem:byOrder"));
        }
        else {
            setTypeSalary(t("common:notFound"));
        }
    }, [])
    return (
        <div className="client-info-container container-box fixed flex flex-center-center">
            <div className="box">
                <button onClick={() => {
                    setSceneEmp({});
                }} className="close">x</button>
                <div className="profile">
                    <h2>{props.data.status ? "🟢" : "🔴"}{props.data.fullName}</h2>
                    <div className="meta at flex flex-space-bet line">
                        <div className="created">
                            {/* updated by (code) */}
                            <p>{t("common:createdAt")}</p>
                            <small>{props.data.meta.createdAt.date}</small>
                            <p className="digital">from: {props.data.meta.createdAt.from}</p>
                        </div>
                        <div className="update right">
                            {/* updated by (code) */}
                            <p>{t("common:updatedAt")}</p>
                            <small>
                            {props.data?.meta?.updatedAt?.length
                                ? props.data.meta.updatedAt[props.data.meta.updatedAt.length - 1]
                                : "- - - - -"}
                            </small>
                        </div>
                    </div>
                    <div className="details line">
                        <p>{t("label:employee.jobTitle.label")}: <span>{props.data.job}</span></p>
                        <p className="right">{t("label:employee.phoneNumber")}: <span>{props.data.details.phone}</span></p>
                        <p className="right">{t("label:employee.address")}: <span>{props.data.details.address}</span></p>
                        <p>{t("label:employee.salary")}: <span>{props.data.salary.value || 0} / {typeSalary}</span></p>
                        <div className="flex flex-space-bet">
                            <p className="right">{t("common:code")}: <span className="digital">{props.data.code || t("common:notFound")}</span></p>
                            <p className="right">{t("auth:username")}: <span className="digital">{props.data.user || t("common:notFound")}</span></p>
                        </div>
                    </div>
                    <div className="money flex flex-space-bet">
                        <div className="dedaction">
                            <p>{t("common:deductions")}</p>
                            {/* bouns from and in (code, at) */}
                            <ul>
                                {props.data?.dedaction && props.data.dedaction.map((item) => 
                                    <li>&larr; {item} {props.currency}</li>
                                )}
                            </ul>
                        </div>
                        <div className="bouns">
                            {/* bouns from and in (code, at) */}
                            <p>{t("common:bouns")}</p>
                            <ul>
                                {props.data?.bouns && props.data.bouns.map((item) => 
                                    <li>&larr; {item} ${props.currency}</li>
                                )}
                            </ul>
                        </div>
                    </div>
                    <div className="work">
                        <h5 className="center">{t("label:employee.hasShift")}</h5>
                        {props.data.shift.shiftDates ? 
                            <div className="shift line flex flex-center-center">
                                <p className="point">{t("common:startIn")}: <span className="error-bg-v2">{props.data.shift?.shiftDates.end || t("common:notFound")}</span></p>
                                <p>&larr;</p>
                                <p className="point">{t("common:endIn")}: <span className="normal-bg-v2">{props.data.shift?.shiftDates.start || t("common:notFound")}</span></p>
                            </div>
                        :
                        <p className="center">{t("common:createWorkTime")}</p>
                    }
                        <div className="holiday">
                            <h5 className="center">{t("label:employee.daysOff")}</h5> 
                            {props.data.shift.holiday 
                            ? 
                                <ul className="days center">
                                    {Days
                                    .filter(day => props.data.shift.holiday.includes(String(day.name)))
                                    .map(day => (
                                        <li className="inline line" key={day.id}>{day.title}</li>
                                    ))
                                    }
                                </ul>
                            :
                                <p className="center">{t("common:noHolidays")}</p>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}